import { render, staticRenderFns } from "./EnFooter.vue?vue&type=template&id=8d3df6a6&scoped=true&"
import script from "./EnFooter.vue?vue&type=script&lang=js&"
export * from "./EnFooter.vue?vue&type=script&lang=js&"
import style0 from "./EnFooter.vue?vue&type=style&index=0&id=8d3df6a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3df6a6",
  null
  
)

export default component.exports